<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import ItemsApi from "@/services/items-api";

export default {
    page: {
        title: "Page de recherche",
        meta: [{ name: "description", content: appConfig.description }]
    },
    components: {Layout},
    props: {
        keyword :{
            type :String
        }

    },
    watch: {
      'keyword': function(){
        this.findCatalogItems()
        this.findOfferItems()
    }
  },

    data () {
        return{
            isItemsCatalogTableBusy: false,
            isItemsOfferTableBusy: false,
            pagemodelMainCatalog: {currentPage : 1, perPage : 5, totalRows: 0},
            pagemodelMainOffer: {currentPage : 1, perPage : 5, totalRows: 0},
            itemsCatalogList: [],
            itemsOfferList: [],
        }
    },
    mounted(){
        this.findCatalogItems()
        this.findOfferItems()
    },
    methods: {
        findCatalogItems() {
            this.isItemsCatalogTableBusy= true;
            ItemsApi.findAllItems(this.keyword, this.pagemodelMainCatalog.currentPage, this.pagemodelMainCatalog.perPage)
            .then(itemsList => {
                if(itemsList){
                this.itemsCatalogList = itemsList.list
                this.pagemodelMainCatalog.totalRows = itemsList.total;
                this.pagemodelMainCatalog.currentPage = itemsList.page;
                this.pagemodelMainCatalog.perPage = itemsList.pageSize;
                this.pagemodelMainCatalog.pageSize = itemsList.pageSize;
                }
            })
            .finally(() => {
            this.isItemsCatalogTableBusy = false;
        })
        },
        findOfferItems() {
            this.isItemsOfferTableBusy= true;
            ItemsApi.findAllPromotionItems(this.keyword, this.pagemodelMainOffer.currentPage, this.pagemodelMainOffer.perPage)
            .then(itemsList => {
                if(itemsList){
                this.itemsOfferList = itemsList.list
                this.pagemodelMainOffer.totalRows = itemsList.total;
                this.pagemodelMainOffer.currentPage = itemsList.page;
                this.pagemodelMainOffer.perPage = itemsList.pageSize;
                this.pagemodelMainOffer.pageSize = itemsList.pageSize;
                }
            })
            .finally(() => {
                this.isItemsOfferTableBusy = false;
            })
        },
    }

}
</script>
<template>
    <Layout>
    <h5 class="m-4">Résultats de Recherche de <span class="font-size-20 font-weight-bold">"{{this.keyword}}"</span> </h5>

    <div class="card border border-info bg-Default p-4 m-4">
        <h4 class="card-title mb-4  text-primary font-size-16">Recherche dans <strong>les offres</strong> </h4>
        <div class="table-responsive mb-0" > 

            <table class="table table-centered table-fixed ">
                <thead class="thead-light">
                    <tr>
                        <th class="text-left">Catalogue</th>
                        <th class="text-left">Désignation</th>
                        <th class="text-left d-md-table-cell d-none">Référence </th>
                        <th class="text-right d-md-table-cell d-none">Prix HT</th>
                        <th class="text-right d-md-table-cell d-none">Remise</th>
                        <th class="text-right">Gratuités</th>
                        <th class="text-right">Prix HT Négocié</th>
                        <th class="text-right d-md-table-cell d-none">Stock</th>
                    </tr>
                </thead>

                <tbody>

                <tr v-for="data in itemsOfferList" :key="data.id" >
                    <td class="text-left font-weight-bold font-size-14">{{data.supplierName}}</td>
                    <td class="text-left font-weight-bold font-size-14">{{data.title}}</td>
                    <td class="text-left d-md-table-cell d-none">{{data.ref}}</td>
                    <td class="text-right font-size-14 d-md-table-cell d-none">{{data.price}}</td>
                    <td class="text-right font-weight-bold font-size-14 d-md-table-cell d-none">{{data.discount === null || data.discount === 0 ? '' : data.discount+'%'}} </td>
                    
                    
                    <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14">
                    </td>

                    <td v-else
                        class="text-right pull-right font-weight-bold font-size-14">

                    <div v-for="(gratuity, index) in data.gratuity" :key="index">
                        <span
                        class="badge badge-primary font-size-14 m-1"
                        >
                        <i class="fas fa-star mr-2"></i>
                        {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                        </span>
                    </div>

                    </td>
                    

                    <td class="text-right font-weight-bold text-success font-size-14">{{data.discountedPrice}}</td>

                    <td class="text-right d-md-table-cell d-none"> 
                    <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
                    <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="isItemsOfferTableBusy" class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                    <span class=" sr-only">Loading...</span>
                </div>
            </div>
            <span v-if="!isItemsOfferTableBusy && !itemsOfferList.length " class="d-flex justify-content-center m-4 text-danger" >Pas d'articles dans le tableau </span>
        </div>

        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findOfferItems()"  v-model="pagemodelMainOffer.perPage" size="sm" style="width: 60px" :options="[5,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMainOffer.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMainOffer.currentPage" :disabled="isItemsCatalogTableBusy" :per-page="pagemodelMainOffer.pageSize" :total-rows="pagemodelMainOffer.totalRows" @input="findOfferItems()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
    </div>


    <div class="card border border-info bg-Default p-4 m-4">
         <h4 class="card-title mb-4  text-primary font-size-16">Recherche dans <strong>les Catalogues</strong> </h4>
        <div class="table-responsive mb-0" >

            <table class="table table-centered table-fixed striped  ">
                <thead class="thead-light">
                    <tr>
                        <th class="text-left">Catalogue</th>
                        <th class="text-left">Désignation</th>
                        <th class="text-left d-md-table-cell d-none">Référence </th>
                        <th class="text-right d-md-table-cell d-none">Prix HT</th>
                        <th class="text-right d-md-table-cell d-none">Remise</th>
                        <th class="text-right">Gratuités</th>
                        <th class="text-right">Prix HT Négocié</th>
                        <th class="text-right d-md-table-cell d-none">Stock</th>
                    </tr>
                </thead>

                <tbody>

                <tr v-for="data in itemsCatalogList" :key="data.id" >
                    <td class="text-left font-weight-bold font-size-14">{{data.supplierName}}</td>
                    <td class="text-left font-weight-bold font-size-14">{{data.title}}</td>
                    <td class="text-left d-md-table-cell d-none">{{data.ref}}</td>
                    <td class="text-right font-size-14 d-md-table-cell d-none">{{data.price}}</td>
                    <td class="text-right font-weight-bold font-size-14 d-md-table-cell d-none">{{data.discount === null || data.discount === 0 ? '' : data.discount+'%'}} </td>
                    
                    <td v-if="!data.gratuity || data.gratuity.length === 0 " class="text-right font-weight-bold font-size-14"> 
                    </td>

                    <td v-else
                        class="text-right pull-right font-weight-bold font-size-14">

                    <div v-for="(gratuity, index) in data.gratuity" :key="index">
                        <span
                        class="badge badge-primary font-size-14 m-1"
                        >
                        <i class="fas fa-star mr-2"></i>
                        {{ gratuity.gratuity }} +{{ gratuity.gratuityGranted }}
                        </span>
                    </div>

                    </td>
                    

                    <td class="text-right font-weight-bold text-success font-size-14">{{data.discountedPrice}}</td>

                    <td class="text-right d-md-table-cell d-none"> 
                    <i v-if="!data.isAvailable" title="Non disponible" class="bx bx-x-circle text-danger font-size-18"> </i>
                    <i v-if="data.isAvailable" title="Disponible en stock" class="fas fa-check-double text-primary font-size-16"> </i>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-if="isItemsCatalogTableBusy" class="d-flex justify-content-center">
                <div class="spinner-border text-success" role="status">
                    <span class=" sr-only">Loading...</span>
                </div>
            </div>
            <span v-if="!isItemsCatalogTableBusy & !itemsCatalogList.length " class="d-flex justify-content-center m-4 text-danger" >Pas d'articles dans le tableau </span>
        </div>

        <!-- Pagination -->
        <div class="row pt-3 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="findCatalogItems()"  v-model="pagemodelMainCatalog.perPage" size="sm" style="width: 60px" :options="[5,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">sur</span><span class="font-weight-bold"> {{pagemodelMainCatalog.totalRows}} lignes</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodelMainCatalog.currentPage" :disabled="isItemsTableBusy" :per-page="pagemodelMainCatalog.pageSize" :total-rows="pagemodelMainCatalog.totalRows" @input="findCatalogItems()" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  -->
    </div>

    </Layout>
</template>